// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"71dd22c4","703":"feeec0a3","787":"fb5ca6f6"}[chunkId] + ".chunk.js";
};